import AppLogos from './AppLogos/AppLogos';
import Header from './Header/Header';

const Headline = () => {
  return (
    <>
      <AppLogos />
      <Header />
    </>
  );
};

export default Headline;
